import React from "react";
import * as yup from "yup";

import { PaziaFileList, PaziaTextarea } from "components/atoms";
import { useSurvey } from "pages/SurveyCreate/store/reducer";
import { Question } from "survey";

interface TextQuestionFormProps {
  question: Question;
}
export const BaseQuestionForm = ({ question }: TextQuestionFormProps) => {
  const { dispatch } = useSurvey();

  const onChange = (fieldName: string, fieldValue: string) =>
    dispatch({
      type: "UPDATE_QUESTION",
      payload: { ...question, [fieldName]: fieldValue },
    });

  return (
    <>
      <PaziaTextarea
        required
        label="Pytanie"
        name={QUESTION_BASE_FORM_NAMES.QUESTION}
        onChange={(e) => onChange(QUESTION_BASE_FORM_NAMES.QUESTION, e.target.value)}
      />
      <PaziaTextarea
        label="Opis"
        name={QUESTION_BASE_FORM_NAMES.DESCRIPTION}
        onChange={(e) => onChange(QUESTION_BASE_FORM_NAMES.DESCRIPTION, e.target.value)}
      />
      <div>
        <PaziaFileList name={QUESTION_BASE_FORM_NAMES.ATTACHMENTS} className="flex flex-col justify-end" multiple />
      </div>
    </>
  );
};
export const QUESTION_BASE_FORM_NAMES = {
  ID: "id",
  QUESTION: "question",
  INDEX: "index",
  DESCRIPTION: "description",
  REQUIRED: "required",
  INPUT_TYPE: "inputType",
  ATTACHMENTS: "attachments",
} as const;

export const questionBaseSchema = yup
  .object({
    [QUESTION_BASE_FORM_NAMES.ID]: yup.string(),
    [QUESTION_BASE_FORM_NAMES.QUESTION]: yup.string().required(),
    [QUESTION_BASE_FORM_NAMES.INDEX]: yup.number(),
    [QUESTION_BASE_FORM_NAMES.DESCRIPTION]: yup.string(),
    [QUESTION_BASE_FORM_NAMES.REQUIRED]: yup.boolean().nullable(),
    [QUESTION_BASE_FORM_NAMES.ATTACHMENTS]: yup.array().of(yup.mixed()),
    [QUESTION_BASE_FORM_NAMES.INPUT_TYPE]: yup.string().required(),
  })
  .required();

export type BaseQuestionFormValues = yup.InferType<typeof questionBaseSchema>;
